<script>
import { required, helpers } from 'vuelidate/lib/validators'

const isUnique = param => value => {
  return !helpers.req(value) || (param && param.indexOf(value) === -1)
}
export default {
  props: {
    value: { type: Array, default: () => [] },
    suggestions: { type: Array, default: () => [] },
    asyncSuggestions: { type: Function },
    allowDuplicates: { type: Boolean, default: false },
    allowCreate: { type: Boolean, default: false },
    clearOnError: { type: Boolean, default: true },
    tagPrefix: { type: String },
    tagSuffix: { type: String },
    labelKey: { type: String, default: 'label' },
    valueKey: { type: String, default: 'id' },
    suggestionIsObject: { type: Boolean, default: false }
  },
  data () {
    return {
      newTag: null,
      options: [],
      tags: [],
      open: false,
      current: 0
    }
  },
  watch: {
    suggestions: {
      handler (v) {
        this.options = v ? [...v] : []
      }
    },
    value: {
      handler (v) {
        this.tags = v ? [...v] : []
      },
      immediate: true
    },
    async newTag (newVal, oldVal) {
      if (newVal === '' || this.current > this.matches.length - 1)
        this.current = 0

      if (
        this.asyncSuggestions &&
        typeof this.asyncSuggestions === 'function' &&
        newVal !== undefined
      ) {
        let items = await this.asyncSuggestions(newVal)
        this.options = [...items]
      }
    }
  },
  validations () {
    let v = {
      required
    }

    if (!this.allowDuplicates) v['duplicate'] = isUnique(this.tags)

    return {
      newTag: {
        ...v
      }
    }
  },
  computed: {
    matches () {
      let tag
      if (typeof this.newTag === 'number') tag = this.newTag
      else if (typeof this.newTag === 'string')
        tag = this.newTag ? this.newTag.toLowerCase() : null

      let matches
      if (this.suggestionIsObject) {
        matches = this.options.filter(o => {
          return o[this.labelKey]
            ? o[this.labelKey].toLowerCase().indexOf(tag) >= 0
            : false
        })
        if (!this.allowDuplicates)
          matches = matches.filter(
            sugg =>
              !this.tags
                .map(t => t[this.valueKey])
                .includes(sugg[this.valueKey])
          )
      } else {
        matches = this.options.filter(str => {
          return str ? str.toLowerCase().indexOf(tag) >= 0 : false
        })
        if (!this.allowDuplicates)
          matches = matches.filter(sugg => !this.tags.includes(sugg))
      }

      return matches
    },
    openSuggestion () {
      return (
        this.newTag !== '' && this.matches.length != 0 && this.open === true
      )
    }
  },
  methods: {
    addTag (event) {
      if (event) event.preventDefault()

      let nTag

      if (this.openSuggestion && this.current >= 0)
        nTag = this.matches[this.current]
      else {
        if (typeof this.newTag === 'number') nTag = this.newTag
        else if (typeof this.newTag === 'string') nTag = this.newTag.trim()
      }

      if (!this.allowCreate && !this.openSuggestion) nTag = null

      if (!this.allowDuplicates) {
        //what to do?
      }

      if (nTag !== null) {
        this.tags = [...this.tags, nTag]
        this.newTag = null
        this.$emit('input', this.tags)
      } else {
        if (this.clearOnError) this.newTag = null
      }

      this.$refs['tag-input_form-input'].focus()
    },
    removeTag (index) {
      this.tags.splice(index, 1)
      this.$emit('input', this.tags)
      this.$refs['tag-input_form-input'].focus()
    },
    removeLastTag (event) {
      if (event.target.value.length === 0) {
        this.removeTag(this.tags.length - 1)
        this.$emit('input', this.tags)
        this.$refs['tag-input_form-input'].focus()
      }
    },

    //When enter pressed on the input
    enter () {
      this.newTag = this.matches[this.current]
      this.open = false
    },

    //When up pressed while suggestions are open
    up () {
      if (this.current > 0) this.current--
    },

    //When up pressed while suggestions are open
    down () {
      if (this.current < this.matches.length - 1) this.current++
    },

    //For highlighting element
    isActive (index) {
      return index === this.current
    },

    //When the user changes input
    change () {
      if (this.open == false) {
        this.open = true
        this.current = 0
      }
    },
    onTabPressed () {
      this.open = false
      this.addTag(null)
    },
    suggestionClick (index) {
      this.addTag(null)
      this.newTag = this.matches[index]
      this.open = false
    }
  }
}
</script>

<template>
  <div class="tag-input align-items-center form-control p-1 flex-wrap">
    <b-input-group>
      <div
        v-for="(tag, index) in tags"
        :key="`${tag}_${index}`"
        class="tag-input__tag px-2 py-1 mx-1 my-1 align-items-center d-flex rounded border-primary border"
      >
        <span>{{ tagPrefix }}</span>
        <template v-if="suggestionIsObject">{{ tag[labelKey] }} </template>
        <template v-else> {{ tag }}</template>
        <span>{{ tagSuffix }}</span>
        <i
          class="bx bx-x font-size-18 ml-2 pointer"
          @click="removeTag(index)"
        ></i>
      </div>

      <b-form-input
        ref="tag-input_form-input"
        type="text"
        v-bind="$attrs"
        class="tag-input__text my-1 p-0 mx-1"
        v-model.number="newTag"
        @keydown.enter="addTag"
        @keydown.188="addTag"
        @keydown.delete="removeLastTag"
        @keydown.down="down"
        @keydown.up="up"
        @keyup.prevent.tab="onTabPressed"
        @input="change"
      />
      <ul
        class="dropdown-menu"
        style="width: 100%"
        v-bind:class="{ show: openSuggestion }"
      >
        <li
          v-for="(suggestion, index) in matches"
          :key="`${suggestion}_${index}`"
          class="dropdown-item pointer"
          :class="{ active: isActive(index) }"
          @click="suggestionClick(index)"
        >
          <template v-if="suggestionIsObject"
            >{{ suggestion[labelKey] }}
          </template>
          <template v-else> {{ suggestion }}</template>
        </li>
      </ul>
    </b-input-group>
  </div>
</template>

<style scoped>
.tag-input {
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  box-sizing: border-box;
  min-height: calc(1.5em + 0.94rem + 2px);
  height: auto;
}

.tag-input__tag {
  font-size: 0.8em;
}

.tag-input__text {
  border: none;
  outline: none;
  background: none;
}
</style>
